import { toast } from "react-toastify";

export function showErrors(errors : string[]){
    errors.forEach((error : string) => {
        toast.error(error);
    });
}